// libs/core/src/lib/constants/endpoint.constants.ts

import { environment } from 'src/environments/environment';
import { GlobalEndpointConstants } from './global-endpoints.constants';

const CUM_V1 = `${GlobalEndpointConstants.CUM}${GlobalEndpointConstants.Version1}cum`;
const CUM_ADMIN = `${GlobalEndpointConstants.CUM}${GlobalEndpointConstants.Version1}cum/adminmanager`;
const DTM_V1 = `${GlobalEndpointConstants.DTM}${GlobalEndpointConstants.Version1}dtm`;
const REPM_V1 = `${GlobalEndpointConstants.Repm}${GlobalEndpointConstants.Version1}rep`;

export const EndpointConstants = {
  // ----------------------------------------------------
  // Configuración / System Constants
  // ----------------------------------------------------
  APP_CODE: 'OFT_RMX_App',
  OCP_APIM: '22b60ff601534e8294d8c4376ea668f2',
  batch: environment.apiBatch,
  EdgeSignalRHub: `${environment.apiManagmet}/refreshhub`,
  ApiEdgeSettings: environment.apiEdgeSettings,

  // ----------------------------------------------------
  // Autenticación & Cuenta (CUM)
  // ----------------------------------------------------
  Auth: {
    Login: `${CUM_V1}/login`,
    Auth: `${CUM_V1}/auth`,
    ValidateEmail: `${CUM_V1}/validateemail`,
    ValidateSendEmail: `${CUM_V1}/validateSendingEmail`,
    LoginByProvider: `${CUM_V1}/loginbyprovider`,
    AccountInfo: `${CUM_V1}/accountinfo`,
    UpdateAccountInfo: `${CUM_V1}/updateaccountinfo`,
    UpdatePassword: `${CUM_V1}/updatepassword`,
    UpdateImageProfile: `${CUM_V1}/updateimageprofile`,
    GetLoginProviders: `${CUM_V1}/getloginproviders`,
    UpdateLoginProvider: `${CUM_V1}/updateloginprovider`,
  },

  // ----------------------------------------------------
  // Administración & Equipos (Admin / CUM)
  // ----------------------------------------------------
  Admin: {
    Companies: `${CUM_ADMIN}/companies`,
    CompanyInfo: `${CUM_V1}/companyinfo`,
    CreateCompany: `${CUM_V1}/createcompany`,
    TeamMembers: `${GlobalEndpointConstants.CustomerManagement}${GlobalEndpointConstants.Version1}cum/teammembers`,
    TeamInvites: `${CUM_V1}/teaminvites`,
    CreateTeamInvite: `${CUM_V1}/createteaminvite`,
    UpdateBusinessPlanByPlant: `${CUM_ADMIN}/updatebusinessplanbyplant`,
    GetAdminUsersByCompany: `${CUM_ADMIN}/getadminusersbycompany`,
  },

  // ----------------------------------------------------
  // Flotas, Camiones & Logística (DTM / Fleet)
  // ----------------------------------------------------
  Trucks: {
    PerPlant: (startDate: string, endDate: string, plants: string) =>
      `${DTM_V1}/trucks/plant?startDate=${startDate}&endDate=${endDate}&plants=${plants}`,
    PerSubGroup: (startDate: string, endDate: string, subgroupId: string) =>
      `${DTM_V1}/trucks/subgroup?startDate=${startDate}&endDate=${endDate}&subgroupid=${subgroupId}`,
    UpdatePlant: `${DTM_V1}/trucks/plant`,
    UpdateOverbooking: `${DTM_V1}/trucks/overbooking`,
    FetchSchedule: (plantId: string) => `${DTM_V1}/trucks/plant/regularshedule?plantId=${plantId}`,
    Replicate: `${DTM_V1}/trucks/plant/replicate`,
  },

  // ----------------------------------------------------
  // Bombeo (Pump Management / Pump Sheet)
  // ----------------------------------------------------
  Pumping: {
    GetVehicles: `pumpmgm/api/PumpManagement/GetVehicles?`,
    GetVehicle: `pumpmgm/api/PumpManagement/GetVehicle?`,
    CreateVehicle: `pumpmgm/api/PumpManagement/CreateVehicle`,
    UpdateVehicle: `pumpmgm/api/PumpManagement/UpdateVehicle`,
    DeleteVehicle: (id: string) => `pumpmgm/api/PumpManagement/DeleteVehicle/${id}`,
    UpdateServiceStatus: 'pumpsheet/api/PumpSheet/UpdateServiceStatus',
    PumpingServices: '/arkik-ordertaking/api/Pump/PumpingServices',
    PumpVehicle: '/arkik-ordertaking/api/Pump/PumpVehicle',
  },

  // ----------------------------------------------------
  // Reportes & Consumos (Reports)
  // ----------------------------------------------------
  Reports: {
    Kpis: (startDate: string, endDate: string, plants: string) =>
      `${REPM_V1}/kpis?startDate=${startDate}&endDate=${endDate}&plants=${plants}`,
    KpisConsumptions: (startDate: string, endDate: string, plants: string, families: string) =>
      `${REPM_V1}/getConsumptions?startDate=${startDate}&endDate=${endDate}&plants=${plants}&idFamilies=${families}`,
    DownloadConcreteTicket: (lang: string, startDate: string, endDate: string, plants: string, status: string) =>
      `${REPM_V1}/concreteticket?lang=${lang}&startDate=${startDate}&endDate=${endDate}&plants=${plants}&ordersStatus=${status}`,
    ProductionQuantities: `${REPM_V1}/ProductionQuantitiesReport`,
  },

  // ----------------------------------------------------
  // Aliases Directos (Compatibilidad Legada)
  // ----------------------------------------------------
  // Permite mantener llamadas existentes `EndpointConstants.ApiLogin` sin romper nada
  get ApiLogin() {
    return this.Auth.Login;
  },
  get ApiAuth() {
    return this.Auth.Auth;
  },
  get ApiValidateemail() {
    return this.Auth.ValidateEmail;
  },
  get ApiTrucksPerPlant() {
    return `${DTM_V1}/trucks/plant?startDate={0}&endDate={1}&plants={2}`;
  },
  get ApiCustomers() {
    return environment.apiRecord;
  },
};
